import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// Datepicker
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, Form, FormCheckbox, FormInput, Icon, Label, Table } from 'semantic-ui-react';

// Actions
import { setContractData, doContractAction } from "./contractSlice";

// Styles
import './contract.css';


//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractHeadOfficeMinStay = ({ editMode }) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const MinStay = Contract.MinStay;

  const { t } = useTranslation();

  // Edit mode?
  const readOnly = editMode ? false : true;
  
  
  
  /**
   * only numbers allowed in allotment max input
   * @param {event} e 
   */
  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };


  
  /**
   * 
   * @param {bool} headoffice 
   */
  const handleAddNewRow = (headoffice = false) => {
    dispatch(doContractAction({target: 'MinStay.addRow', value: headoffice}))
  }



  /**
   * 
   */
  const handleDeleteRow = (rowIndex) => {
    dispatch(doContractAction({target: 'MinStay.deleteRow', value: rowIndex}))
  }



  /**
   * 
   */
  const handleCopyRow = (rowIndex) => {
    dispatch(doContractAction({target: 'MinStay.copyRow', value: rowIndex}))
  }

  // If no records
  if (typeof MinStay === 'undefined' || !MinStay || !MinStay.length) {
    return (
    <>
    {!readOnly && (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRow')}
      </Button>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRowHeadOffice')}
      </Button>
      </>
    )}
    </>);
  }

  return (
    <>
    <Table celled structured striped basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.from')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.to')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.monShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.tueShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.wedShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.thuShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.friShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.satShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.sunShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.days')}</Table.HeaderCell>
          {!readOnly && (
            <Table.HeaderCell></Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {MinStay.map((minstay, minstayKey)=>(
          <Table.Row key={minstayKey}>
            <Table.Cell>
              {!minstay.Additional && (<Label as='a' color='red' ribbon>{t('settings.userDetails.headOffice')}</Label>)}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(minstay.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected={minstay.Start}
                  startDate={minstay.Start}
                  endDate={minstay.End}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'MinStay.Start', row: minstayKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(minstay.End, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected={minstay.End}
                  startDate={minstay.Start}
                  endDate={minstay.End}
                  minDate={minstay.Start}
                  dateFormat="dd.MM.yyyy"
                  placeholder='TT.MM.JJJJ'
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(minstay.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'MinStay.End', row: minstayKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.mon ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.mon ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'mon', value: !minstay.Weekdays.mon }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.tue ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.tue ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'tue', value: !minstay.Weekdays.tue }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.wed ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.wed ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'wed', value: !minstay.Weekdays.wed }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.thu ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.thu ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'thu', value: !minstay.Weekdays.thu }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.fri ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.fri ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'fri', value: !minstay.Weekdays.fri }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.sat ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.sat ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'sat', value: !minstay.Weekdays.sat }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{minstay.Weekdays.sun ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={minstay.Weekdays.sun ? true : false} onClick={() => dispatch(setContractData({target: 'MinStay.Weekday', row: minstayKey,  weekday: 'sun', value: !minstay.Weekdays.sun }))} />}</Table.Cell>
            <Table.Cell>
              {readOnly ? <>{minstay.Value}</> : <Form><FormInput type="number" maxLength={2} onKeyPress={handleKeyPress} style={{width: "70px"}} value={minstay.Value} onChange={(e, data) => dispatch(setContractData({target: 'MinStay.Value', row: minstayKey,  value: data.value}))} /></Form>}
            </Table.Cell>
            {!readOnly && (
              <Table.Cell>
                <Button basic circular icon>
                  <Icon name='trash' onClick={() => handleDeleteRow(minstayKey)} />
                </Button>
                <Button basic circular icon>
                  <Icon name='copy outline' onClick={() => handleCopyRow(minstayKey)} />
                </Button>
              </Table.Cell>
            )}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    {!readOnly && (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
        <Icon name='plus' />
        Zeile hinzufügen
      </Button>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        Zeile hinzufügen (HeadOffice)
      </Button>
      </>
    )}
    </>
  );
}

export default Max2ContractHeadOfficeMinStay;
